import { supabase } from "@/integrations/supabase/client";
import { getStripeEnvironment } from "@/lib/stripe";

export interface ConnectAccount {
  stripe_account_id: string;
  environment: "sandbox" | "live";
  country: string | null;
  default_currency: string | null;
  payouts_enabled: boolean;
  details_submitted: boolean;
  charges_enabled: boolean;
  requirements_currently_due: string[];
  disabled_reason: string | null;
}

export async function fetchConnectAccount(
  userId: string,
): Promise<ConnectAccount | null> {
  const { data, error } = await supabase
    .from("affiliate_connect_accounts")
    .select(
      "stripe_account_id, environment, country, default_currency, payouts_enabled, details_submitted, charges_enabled, requirements_currently_due, disabled_reason",
    )
    .eq("affiliate_user_id", userId)
    .eq("environment", getStripeEnvironment())
    .maybeSingle();
  if (error) throw error;
  return (data as ConnectAccount | null) ?? null;
}

export async function startConnectOnboarding(): Promise<string> {
  const { data, error } = await supabase.functions.invoke("affiliate-connect-onboard", {
    body: { environment: getStripeEnvironment() },
  });
  if (error) throw error;
  if (!data?.url) throw new Error(data?.error ?? "Onboarding URL missing");
  return data.url as string;
}

export async function refreshConnectAccount(): Promise<ConnectAccount | null> {
  const { data, error } = await supabase.functions.invoke("affiliate-connect-refresh", {
    body: { environment: getStripeEnvironment() },
  });
  if (error) throw error;
  return (data?.account as ConnectAccount | null) ?? null;
}

export async function openConnectDashboard(): Promise<string> {
  const { data, error } = await supabase.functions.invoke(
    "affiliate-connect-dashboard-link",
    { body: { environment: getStripeEnvironment() } },
  );
  if (error) throw error;
  if (!data?.url) throw new Error(data?.error ?? "Dashboard URL missing");
  return data.url as string;
}
